import i18n from '@/plugins/i18n'

const currencyFormatter = new Intl.NumberFormat(
    i18n.locale,
    {
        minimumFractionDigits: 2
    }
)

export default {
    getCurrencyFormat (num) {
        return currencyFormatter.format(num)
    },

    getTwoDigitNumber (num) {
        return num < 10 ? `0${num}` : `${num}`
    },

    getDDMMYYYYHHSSDateFormat (date) {
        if (!date) {
            return ''
        }

        return `${this.getDDMMYYYYDateFormat(date)} ${this.getHHSSDateFormat(date)}`
    },

    getHHSSDateFormat (date) {
        if (!date) {
            return ''
        }

        const dateInstance = new Date(date)
        const formattedHours = this.getTwoDigitNumber(dateInstance.getHours())
        const formattedMinutes = this.getTwoDigitNumber(dateInstance.getMinutes())
        return `${formattedHours}:${formattedMinutes}`
    },

    getDDMMYYYYDateFormat (date) {
        if (!date) {
            return ''
        }

        const dateInstance = new Date(date)
        const formattedDate = this.getTwoDigitNumber(dateInstance.getDate())
        const formattedMonth = this.getTwoDigitNumber(dateInstance.getMonth() + 1)
        const formattedYear = dateInstance.getFullYear() + parseInt(i18n.t('date.addedYear'))

        return `${formattedDate}/${formattedMonth}/${formattedYear}`
    },

    fileToImage (file) {
        return new Promise((resolve, reject) => {
            const image = new Image()
            image.onload = function () {
                resolve(image)
            }
            image.onerror = function (err) {
                reject(err)
            }
            image.src = URL.createObjectURL(file)
        })
    },

    downloadBlob (blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
            const a = document.createElement('a')
            document.body.appendChild(a)
            const url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = fileName
            a.click()
            setTimeout(() => {
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
            }, 0)
        }
    },

    getQueryString (queryObject) {
        if (!queryObject) {
            return ''
        }

        let queryString = ''
        Object.entries(queryObject).forEach(entries => {
            const [key, value] = entries
            if (value && value !== '') {
                if (queryString !== '') {
                    queryString += '&'
                }
                queryString += `${key}=${value}`
            }
        })

        return queryString
    },

    buildUrlWithQuery (url, queryObject) {
        const queryString = this.getQueryString(queryObject)
        let processedUrl = url
        if (queryString !== '') {
            processedUrl += `?${queryString}`
        }

        return processedUrl
    }
}
